var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraghandler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 6.125C10.75 6.74632 11.2537 7.25 11.875 7.25C12.4963 7.25 13 6.74632 13 6.125C13 5.50368 12.4963 5 11.875 5C11.2537 5 10.75 5.50368 10.75 6.125ZM10.75 10.125C10.75 10.7463 11.2537 11.25 11.875 11.25C12.4963 11.25 13 10.7463 13 10.125C13 9.50368 12.4963 9 11.875 9C11.2537 9 10.75 9.50368 10.75 10.125ZM7.875 11.25C7.25368 11.25 6.75 10.7463 6.75 10.125C6.75 9.50368 7.25368 9 7.875 9C8.49632 9 9 9.50368 9 10.125C9 10.7463 8.49632 11.25 7.875 11.25ZM6.75 6.125C6.75 6.74632 7.25368 7.25 7.875 7.25C8.49632 7.25 9 6.74632 9 6.125C9 5.50368 8.49632 5 7.875 5C7.25368 5 6.75 5.50368 6.75 6.125ZM3.875 11.25C3.2537 11.25 2.75 10.7463 2.75 10.125C2.75 9.50368 3.2537 9 3.875 9C4.4963 9 5 9.50368 5 10.125C5 10.7463 4.4963 11.25 3.875 11.25ZM2.75 6.125C2.75 6.74632 3.2537 7.25 3.875 7.25C4.4963 7.25 5 6.74632 5 6.125C5 5.50368 4.4963 5 3.875 5C3.2537 5 2.75 5.50368 2.75 6.125Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraghandler);
export default __webpack_public_path__ + "static/media/draghandler.90978784ddcb2cb8d2117e7ecfb93e38.svg";
export { ForwardRef as ReactComponent };